export const light = {
    libretto: {
        bgCanvas: '#F5F6F7',
        bgSurface: '#FFFFFF',
        bgSubtle: '#F3F4F6',
        borderSubtle: '#E5E7EB',
        borderMuted: '#D1D5DB',
        timelineClipBorder: '#94A3B8',
        timelineClipBorderStrong: '#64748B',
        timelineClipSelection: '#2B6BFD',
        timelineTrimHandleSurface: '#F8FAFC',
        timelineTrimHandleGrip: '#2B6BFD',
        videoClipSurface: '#BFDDE8',
        videoClipSurfaceHover: '#B4D5E2',
        videoClipBorder: '#5F8292',
        videoClipText: '#213E4B',
        audioClipSurface: '#D8D1F0',
        audioClipSurfaceHover: '#CDC5EA',
        audioClipBorder: '#766EA1',
        audioClipText: '#38325F',
        imageClipSurface: '#A9DDBF',
        imageClipSurfaceHover: '#9ED4B5',
        imageClipBorder: '#4F8869',
        imageClipText: '#214C36',
        captionsClipSurface: '#D8DCE3',
        captionsClipSurfaceHover: '#CDD2DA',
        captionsClipBorder: '#747E8C',
        captionsClipText: '#343B47',
        textClipSurface: '#E8D7B7',
        textClipSurfaceHover: '#DECAA5',
        textClipBorder: '#927A54',
        textClipText: '#4D3A20',
        scriptClipSurface: '#C8D5E3',
        scriptClipSurfaceHover: '#C2D0DF',
        scriptClipBorder: '#60748A',
        scriptClipText: '#293B4F',
        scriptClipWaveform: '#374151',
        scriptClipDivider: 'rgba(51, 65, 85, 0.66)',
        scriptClipDividerStrong: 'rgba(51, 65, 85, 0.82)',
        scriptClipDividerHighlight: 'rgba(255, 255, 255, 0.20)',
        scriptClipCut: 'rgba(51, 65, 85, 0.58)',
		scriptClipGapHover: 'rgba(51, 65, 85, 0.11)',
        scriptClipInsetHighlight: 'rgba(255, 255, 255, 0.42)',
        textPrimary: '#1A1A1A',
        textMuted: '#6B7280',
        textSubtle: '#9CA3AF',
        iconPrimary: '#4B5563',
        fillerHighlight: '#FEF3C7',
        fillerHighlightActive: '#FED7AA',
    },
    alternate: {
        main: '#f7faff',
        dark: '#edf1f7',
    },
    cardShadow: 'rgba(23, 70, 161, .11)',
    mode: 'light',
    primary: {
        main: '#2B6BFD',
        light: '#467de3',
        dark: '#2f6ad9',
        contrastText: '#ffffff',
    },
    secondary: {
        light: '#ffb74d',
        main: '#f9b934',
        dark: '#FF9800',
        contrastText: 'rgba(0, 0, 0, 0.87)',
    },
    text: {
        primary: '#1e2022',
        secondary: '#8B8C90',
    },
    divider: 'rgba(0, 0, 0, 0.12)',
    background: {
        paper: '#FFFFFF',
        default: '#F5F6F7',
        level2: '#F3F4F6',
        level1: '#FFFFFF',
    },
};

export const dark = {
    libretto: {
        bgCanvas: '#121418',
        bgSurface: '#1A1D23',
        bgSubtle: '#232833',
        borderSubtle: '#313845',
        borderMuted: '#3C4554',
        timelineClipBorder: '#5F6C80',
        timelineClipBorderStrong: '#7C8CA3',
        timelineClipSelection: '#6EA0FF',
        timelineTrimHandleSurface: '#F8FAFC',
        timelineTrimHandleGrip: '#2B6BFD',
        videoClipSurface: '#315665',
        videoClipSurfaceHover: '#3A6272',
        videoClipBorder: '#78A3B4',
        videoClipText: '#EFFAFF',
        audioClipSurface: '#4A446D',
        audioClipSurfaceHover: '#554E7B',
        audioClipBorder: '#9991C3',
        audioClipText: '#F6F3FF',
        imageClipSurface: '#345F4B',
        imageClipSurfaceHover: '#3C6C56',
        imageClipBorder: '#7BB095',
        imageClipText: '#EEFFF6',
        captionsClipSurface: '#414852',
        captionsClipSurfaceHover: '#4B535F',
        captionsClipBorder: '#8994A3',
        captionsClipText: '#F4F7FA',
        textClipSurface: '#5B4D36',
        textClipSurfaceHover: '#69583D',
        textClipBorder: '#A99069',
        textClipText: '#FFF8EA',
        scriptClipSurface: '#344256',
        scriptClipSurfaceHover: '#3B4B61',
        scriptClipBorder: '#8192A7',
        scriptClipText: '#F4F7FA',
        scriptClipWaveform: '#D6E0EA',
        scriptClipDivider: 'rgba(190, 203, 218, 0.66)',
        scriptClipDividerStrong: 'rgba(214, 224, 234, 0.82)',
        scriptClipDividerHighlight: 'rgba(15, 23, 42, 0.34)',
        scriptClipCut: 'rgba(190, 203, 218, 0.58)',
		scriptClipGapHover: 'rgba(255, 255, 255, 0.12)',
        scriptClipInsetHighlight: 'rgba(255, 255, 255, 0.12)',
        textPrimary: '#F5F7FA',
        textMuted: '#A7B0BC',
        textSubtle: '#8C97A6',
        iconPrimary: '#A7B0BC',
        fillerHighlight: '#54461A',
        fillerHighlightActive: '#6A4318',
    },
    alternate: {
        main: '#1a2138',
        dark: '#151a30',
    },
    cardShadow: 'rgba(0, 0, 0, .11)',
    common: {
        black: '#000',
        white: '#fff',
    },
    mode: 'dark',
    primary: {
        main: '#2B6BFD',
        light: '#2196f3',
        dark: '#1E4FC4',
        contrastText: '#FFFFFF',
    },
    secondary: {
        light: '#FFEA41',
        main: '#FFE102',
        dark: '#DBBE01',
        contrastText: 'rgba(0, 0, 0, 0.87)',
    },
    text: {
        primary: '#F5F7FA',
        secondary: '#A7B0BC',
    },
    divider: 'rgba(255, 255, 255, 0.12)',
    background: {
        paper: '#1A1D23',
        default: '#121418',
        level2: '#232833',
        level1: '#1A1D23',
    },
};
